import React, { useState } from 'react';
import { Form, Button, InputGroup, Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { duplicate } from '../../services/project/formGroupService';

const FormGroupSelector = ({
  formGroups,
  projectId,
  selectedFormGroupId,
  setSelectedFormGroupId,
  onToggleGroupActive,
  onDuplicate
}) => {
  const [formGroupName, setFormGroupName] = useState('');
  const selectedGroup = formGroups.find(g => g.id === Number(selectedFormGroupId));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formGroupName.trim()) return;
    try {
      const { formGroup } = await duplicate(projectId, selectedFormGroupId, formGroupName);
      await onDuplicate();
      setFormGroupName('');
      setSelectedFormGroupId(formGroup.id);
      toast.success('FormGroup duplicated successfully');
      //fetchForms();
    } catch (err) {
      console.error('Error duplicating form group:', err);
      toast.error('Error duplicating form group');
    }
  };
  return (
    <>
      <h4>Form Group</h4>
      <Form.Select
        className="mb-3"
        value={selectedFormGroupId}
        onChange={(e) => setSelectedFormGroupId(e.target.value)}
      >
        <option value="">Select Group</option>
        {formGroups.map((g) => (
          <option key={g.id} value={g.id}>
            {g.name} {g.isActive ? "(Active)" : ""}
          </option>
        ))}
      </Form.Select>

      {selectedGroup && !selectedGroup.isActive && (
        <Button
          className="mb-4"
          variant="success"
          onClick={() => onToggleGroupActive(selectedGroup.id)}
        >
          Set Active
        </Button>
      )}
      <Form onSubmit={handleSubmit} style={{ paddingBottom: 20 }}>
        <InputGroup>
          <Form.Control
            type="text"
            placeholder="Enter New Form Group Name"
            value={formGroupName}
            onChange={(e) => setFormGroupName(e.target.value)}
            required
          />
          <Button type="submit" variant="primary">
            Duplicate
          </Button>
        </InputGroup>
      </Form>
    </>
  );
};

export default FormGroupSelector;
